import { Preferences } from "@capacitor/preferences";

export const setUser = async (user) => {
  await Preferences.set({
    key: "user",
    value: JSON.stringify(user),
  });
};

export const getUser = () => {
  return Preferences.get({ key: "user" }).then(({ value }) => {
    return value ? JSON.parse(value) : null;
  });
};

export const removeCookie = async (key) => {
  await Preferences.remove({ key: key });
};


export const getUniqueDataById = (prevData, newData, idKey = "id") => {
  const combinedData = [...prevData, ...newData];
  const uniqueDataMap = new Map();

  combinedData.forEach((item) => {
    uniqueDataMap.set(item[idKey], item);
  });

  return Array.from(uniqueDataMap.values());
};

// Helper to capitalize each word
export const toProperCase = (str) => {
  if (!str) return "N/A";
  return str
    .toLowerCase()
    .replace(/_/g, " ")
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

// Helper to format date
export const getFormattedDate = (dateString) => {
  if (!dateString) return "N/A";
  const date = new Date(dateString);
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const getFormattedNumber = (value, digits = 2) => {
  value = parseFloat(value);
  if (!isNaN(value)) {
    return value.toLocaleString("en-IN", {
      style: "decimal",
      minimumFractionDigits: 0,
      maximumFractionDigits: digits
    });
  } else return 0;
};

export const formatIndianAmount = (amount, round=2) => {
  if (isNaN(amount)) return "0";
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: round
  }).format(amount);
};